import styled from 'styled-components';
import { normalize } from 'utils/styles';

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${normalize('150px')};
`;

export const Container = styled.div`
  margin-bottom: 60px;
`;
